var map = {
	"./USD.png": 2663,
	"./aed.png": 1041,
	"./celo.png": 6728,
	"./cusd.png": 2414,
	"./etb.png": 780,
	"./gbp.png": 4234,
	"./ghs.png": 9907,
	"./kes.png": 7104,
	"./ngn.png": 5606,
	"./tzs.png": 7246,
	"./ugx.png": 1735,
	"./usdc.png": 9468,
	"./usdt.png": 83,
	"./xlm.png": 1742,
	"./zar.png": 8048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1748;